var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGnbAroundOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3C13.93 3 17 4.4 17 8.15C17 10.31 15.28 12.82 12 15.47C8.72 12.82 7 10.3 7 8.15C7 4.4 10.07 3 12 3ZM12 1C8.73 1 5 3.46 5 8.15C5 11.27 7.33 14.56 12 18C16.67 14.56 19 11.27 19 8.15C19 3.46 15.27 1 12 1Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6C10.9 6 10 6.9 10 8C10 9.1 10.9 10 12 10C12.5304 10 13.0391 9.78929 13.4142 9.41421C13.7893 9.03914 14 8.53043 14 8C14 7.46957 13.7893 6.96086 13.4142 6.58579C13.0391 6.21071 12.5304 6 12 6ZM5 19H19V21H5V19Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGnbAroundOff);
export default __webpack_public_path__ + "static/media/gnb_around_off.85491816dc3be221b24273963f1db20a.svg";
export { ForwardRef as ReactComponent };